import React from 'react';
import '../../styles/copyRights.scss';
import { Link } from 'react-router-dom';
function CopyRights() {
	const date = new Date();
	const getCurrentYear = date.getFullYear();

	return (
		<>
			<div className="copy-right-page">
				Copyright &copy; {getCurrentYear} .Design & Developed by&nbsp;
				<Link to="https://webdads2u.com/" target="_blank">
					WEBDADS2U PRIVATE LIMITED
				</Link>
				&nbsp; All Rights Reserved.
			</div>
		</>
	);
}

export default CopyRights;
